import { authorizedFetch as fetch, fetchPOST } from '@/helpers/authFetch';
import checkedFetch from '@/utils/fetchers';
import { affectedVehiclesEndPoint, checkServiceOK } from './serviceConstants';

const getVehiclesModelDesignation = (data) => (
  fetchPOST(`${affectedVehiclesEndPoint}/vehicle-model-designation`, data)
    .then((res) => checkServiceOK(res, true)));

const getEnginesModelDesignation = (data) => (
  fetchPOST(`${affectedVehiclesEndPoint}/engine-model-designation`, data)
    .then((res) => checkServiceOK(res, true)));

const getOnlyPlantsOptions = (fromAffectedVehicles = false) => (
  fetch(`${affectedVehiclesEndPoint}/plants${fromAffectedVehicles ? '-selectionMode' : ''}`).then((res) => checkServiceOK(res))
);

const getFinNumberValidation = (fin) => (
  fetch(`${affectedVehiclesEndPoint}/efa-input/fin/${fin}/validate`).then((res) => checkServiceOK(res))
);

const getSeriesByPlant = (wkzNumber) => (
  fetch(`${affectedVehiclesEndPoint}/series/${wkzNumber}/by-plant`).then((res) => checkServiceOK(res))
);

const getSeriesByPlantList = (wkzNumbers = []) => (
  fetch(`${affectedVehiclesEndPoint}/series/by-plants?${wkzNumbers.map((p) => `wkzNumbers=${p}`).join('&')}`).then((res) => checkServiceOK(res))
);

const gePlantsBySerieList = (series = []) => (
  fetch(`${affectedVehiclesEndPoint}/series/by-model-series?${series.map((s) => `modelSeries=${s}`).join('&')}`).then((res) => checkServiceOK(res))
);

const getModelSeries = (fromAffectedVehicles = false) => (
  checkedFetch(`${affectedVehiclesEndPoint}/series/${fromAffectedVehicles ? 'selectionMode' : 'model-series'}`, [])
);
const getModelSeriesEfa = () => checkedFetch(`${affectedVehiclesEndPoint}/efa-input/model-series`, []);
const getPlantsByBodyTypes = (serie) => checkedFetch(`${affectedVehiclesEndPoint}/series/${serie}`, {});
const getCountryVariants = () => checkedFetch(`${affectedVehiclesEndPoint}/country-variant`, []);
const getPaintCodes = () => checkedFetch(`${affectedVehiclesEndPoint}/paint-code`, []);
const getEfaInput = (serie) => checkedFetch(`${affectedVehiclesEndPoint}/efa-input/${serie}`, {});

export default {
  getModelSeriesEfa,
  getModelSeries,
  getPlantsByBodyTypes,
  getVehiclesModelDesignation,
  getEnginesModelDesignation,
  getCountryVariants,
  getPaintCodes,
  getEfaInput,
  getOnlyPlantsOptions,
  getFinNumberValidation,
  getSeriesByPlant,
  getSeriesByPlantList,
  gePlantsBySerieList,
};
